const themes = {
  softinya: () => import("./softinya/HomePage.vue"),
  azcon: () => import("./azcon/HomePage.vue"),
};

export function getHomeTheme(type) {
  return themes[type] || themes.softinya;
}
